/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import {
  ActionManager,
  ActionManagerFn,
  RequiredItem,
} from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { dataLevelType } from '../../registry/constants';
import { defaultValue } from './ActionSetData';

const ActionSetDataManager: ActionManagerFn<'ActionSetData'> = (
  platform: Platform,
): ActionManager<'ActionSetData'> => {
  return {
    ...baseActionManager(platform, 'ActionSetData'),
    defaultValue,
    props: {
      ...baseActionProps,
      dataLevel: {
        label: 'Level',
        type: 'select',
        options: dataLevelType,
        required: true,
      },
      key: {
        label: 'Key',
        type: 'expression',
        returnType: async () => 'string',
        required: true,
        helpText: (item: RequiredItem<'ActionSetData'>) =>
          `Once set, you can later access this value using the expression $.$${
            item.props.dataLevel
          }Data.${
            (typeof item.props.key === 'string'
              ? item.props.key
              : item.props.key.value) || '<key>'
          }`,
      },
      value: {
        label: 'Value',
        type: 'expression',
        returnType: async () => 'any',
        required: true,
      },
    },
    name: 'Set Data',
    getDisplayText: (item) =>
      typeof item.props.key === 'string'
        ? item.props.key
        : item.props.key.value,
    description: `Use this action to store any data either at Page or Global level.

Data set at Page level can only be accessed within the same page using the following expression
\`\`\`javascript
$.$pageData.<key>
\`\`\`

Data set at Global level can be accessed accross pages using the following expression
\`\`\`javascript
$.$globalData.<key>
\`\`\`

\`\`\`alert
Note: Replace <key> with the value specified for the Key property
\`\`\`

`,
  };
};

export default ActionSetDataManager;
